import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarPreferenceList } from "../../../../../../../services/calendarPreference.service";
import { IReceivedMessageCalePreferencesProps } from "../models";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessages.";

export const ReceivedMessageCalePreferences = memo(
  ({ automationCode }: IReceivedMessageCalePreferencesProps) => {
    const { t } = useTranslation();

    const { sendRequest: calendarPreferenceRequest } = useFetch(
      calendarPreferenceList,
    );

    const [optionsPreferences, setOptionsPreferences] = useState<ISelectType[]>(
      [],
    );

    const params = useMemo(() => {
      const baseParams = { EnableCode: true };
      if (automationCode === "21") {
        return { ...baseParams, TasyScheduleTypeCode: ["2"] };
      }
      return { ...baseParams, TasyScheduleTypeCode: ["3"] };
    }, []);

    const fetchCalendarPreferences = useCallback(async () => {
      const { data, success } = await calendarPreferenceRequest(params);
      if (data && success) {
        setOptionsPreferences(
          data.map((d) => ({
            id: d.identifier.toString(),
            name: d.preference,
          })),
        );
      }
    }, [calendarPreferenceRequest]);

    useEffect(() => {
      fetchCalendarPreferences();
    }, [fetchCalendarPreferences]);

    return (
      <Grid item xs={12} sm={12}>
        <AutoCompleteMulti
          params={params}
          fullWidth
          options={optionsPreferences}
          name="calendarPreferences"
          label={t(translationPath + "preference")}
          getOptionLabel={(option) => option.name}
          size="small"
          keepOpenOnSelect
        />
      </Grid>
    );
  },
);
